import { render, staticRenderFns } from "./AssistantChat.vue?vue&type=template&id=71fd4022&scoped=true"
import script from "./AssistantChat.vue?vue&type=script&lang=js"
export * from "./AssistantChat.vue?vue&type=script&lang=js"
import style0 from "./AssistantChat.vue?vue&type=style&index=0&id=71fd4022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd4022",
  null
  
)

export default component.exports